import { InputAdornment, TextField } from "@mui/material";
import type { FC } from "react";
import { NumericFormat } from "react-number-format";

import { inputRangeSx } from "~/components/UI/FilterRange/components/InputRange/InputRange.styles";

interface ActivityNumberInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  placeholder: string;
  prefix?: string;
  suffix?: string;
  allowNegative?: boolean;
  error?: boolean;
}

export const ActivityNumberInput: FC<ActivityNumberInputProps> = ({
  value,
  onChange,
  placeholder,
  prefix,
  suffix,
  allowNegative = false,
  error,
}) => (
  <NumericFormat
    customInput={TextField}
    sx={inputRangeSx}
    value={value ?? ""}
    variant="outlined"
    size="small"
    thousandSeparator
    allowNegative={allowNegative}
    decimalScale={0}
    placeholder={placeholder}
    error={error}
    onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
    slotProps={{
      input: {
        startAdornment: prefix && (
          <InputAdornment position="start">{prefix}</InputAdornment>
        ),
        endAdornment: suffix && (
          <InputAdornment position="end">{suffix}</InputAdornment>
        ),
      },
      htmlInput: { inputMode: "decimal" },
    }}
  />
);
